// extracted by mini-css-extract-plugin
export default {"container":"body_container__1JOdj","withoutMaxWidth":"body_withoutMaxWidth__1kLRI","inherit":"body_inherit__2EBdE"};